import {EntitySureFlowUnit} from './entity-sure-flow-unit';
import {TagInformation} from './tag-information';

export class SureFlowEntityUnitRatingInput {

  unit!: EntitySureFlowUnit;
  tagInformation!: TagInformation;

}
